import _ from 'lodash'
import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import {
  CLEAR_EVENTS,
  UPDATE_EVENT_IN_LIST,
  STORE_PARENT_EVENT,
  CLEAR_PARENT_EVENT,
  UPDATE_BULK_UPDATED_EVENT_COUNT,
  CLEAR_BULK_UPDATED_EVENT_COUNT,
} from '../../constants/actionTypes'
import { EVENTS } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
  eventsUpdated: 0,
  eventCount: 0,
}

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EVENTS:
      return initialState
    case UPDATE_BULK_UPDATED_EVENT_COUNT:
      return {
        ...state,
        eventsUpdated: state.eventsUpdated + action.eventsUpdated,
        eventCount: action.eventCount,
      }
    case CLEAR_BULK_UPDATED_EVENT_COUNT:
      return {
        ...state,
        eventsUpdated: 0,
        eventCount: 0,
      }
    case UPDATE_EVENT_IN_LIST: {
      const updatedEvent = action.event
      if (
        state.total_elements > 0 &&
        state.content &&
        state.content.length > 0
      ) {
        const matchIndex = _.findIndex(state.content, {
          event_id: updatedEvent.event_id,
        })
        if (matchIndex > -1) {
          // replace with new updatedEvent
          return Object.assign({}, state, {
            content: Object.assign([...state.content], {
              [matchIndex]: updatedEvent,
            }),
          })
        }
        return state
      } else {
        return state
      }
    }
    case STORE_PARENT_EVENT:
      return Object.assign({}, state, {
        parentEvent: action.event,
      })
    case CLEAR_PARENT_EVENT:
      return Object.assign({}, state, {
        parentEvent: {},
      })
    case `REPLACE_TABLE_USER_INFO_${EVENTS}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        EVENTS,
        state,
        action
      )
    default:
      return reducers.dataTable.tableFetchReducer(EVENTS, state, action)
  }
}
const eventsDownloadReducer = (state = initialState, action) =>
  reducers.dataTable.downloadFetchReducer(EVENTS, state, action)

export default combineReducers({
  data: eventsReducer,
  tableInfo: tableReducer,
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(EVENTS, state, action),
  savedSearches: (state, action) =>
    reducers.dataTable.savedSearchesReducer(EVENTS, state, action),
  downloadData: eventsDownloadReducer,
})
export { initialState, eventsReducer }
